import { render, staticRenderFns } from "./SkillTableMobile.vue?vue&type=template&id=aaf0ded8&scoped=true&"
import script from "./SkillTableMobile.vue?vue&type=script&lang=js&"
export * from "./SkillTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./SkillTableMobile.vue?vue&type=style&index=0&id=aaf0ded8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf0ded8",
  null
  
)

export default component.exports